export default function windowModal() {
  window.Modal = function () {
    let reg = new RegExp("\\[([^\\[\\]]*?)\\]", "igm");
    let alr = $("#ycf-alert");
    let ahtml = alr.html();

    let _alert = function (options) {
      alr.html(ahtml);
      alr.find(".ok").removeClass("btn-success").addClass("btn-primary");
      alr.find(".cancel").hide();
      _dialog(options);

      return {
        on: function (callback) {
          if (callback && callback instanceof Function) {
            alr.find(".ok").click(function () { callback(true) });
          }
        }
      };
    };

    let _confirm = function (options) {
      alr.html(ahtml);
      alr.find(".ok").removeClass("btn-primary").addClass("btn-success");
      alr.find(".cancel").show();
      _dialog(options);

      return {
        on: function (callback) {
          if (callback && callback instanceof Function) {
            alr.find(".ok").click(function () { callback(true) });
            alr.find(".cancel").click(function () { callback(false) });
          }
        }
      };
    };

    let _dialog = function (options) {
      let ops = {
        msg: "Content Assist",
        title: "Information Tips",
        btnok: "Confirm",
        btncl: "Cancel"
      };

      $.extend(ops, options);

      let html = alr.html().replace(reg, function (node, key) {
        return {
          Title: ops.title,
          Message: ops.msg,
          BtnOk: ops.btnok,
          BtnCancel: ops.btncl
        }[key];
      });

      alr.html(html);
      alr.modal({
        width: 500,
        backdrop: "static"
      });
    };

    return {
      alert: _alert,
      confirm: _confirm
    }
  }();
};



// WEBPACK FOOTER //
// ./src/component/Modal.js